import React, { useState, useEffect } from 'react';
import './Hero.css';

const SLIDES = [
  {
    image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1920&q=80',
    alt: 'İSO belgeleri ve kalite yönetimi',
    title: 'İSO Belgeleri ve Kalite Yönetim Sistemleri',
    subtitle: 'İSO 9001, 14001, 22000, 27001 ve diğer belgeler için danışmanlık ve belgelendirme hizmeti.',
    page: 'products',
    buttonText: 'İSO Belgeleri',
  },
  {
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1920&q=80',
    alt: 'Kalite standartları',
    title: 'Kalite Yönetim Danışmanlığı',
    subtitle: 'İşletmeniz için doğru İSO standardını seçin; süreçlerinizi uluslararası standartlara taşıyın.',
    page: 'about',
    buttonText: 'Hakkımızda',
  },
  {
    image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1920&q=80',
    alt: 'Sıkça sorulan sorular',
    title: 'İSO Belgesi Hakkında Sorularınız mı var?',
    subtitle: 'İSO süreçleri, belgelendirme ve danışmanlık hakkında sık sorulan sorular.',
    page: 'faq',
    buttonText: 'S.S.S.',
  },
  {
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=1920&q=80',
    alt: 'İSO ve kalite içerikleri',
    title: 'İSO ve Kalite Yazıları',
    subtitle: 'Kalite yönetim sistemleri, İSO güncellemeleri ve belgelendirme rehberleri.',
    page: 'blog',
    buttonText: 'Blog',
  },
];

const Hero = ({ onNavigate }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index) => setActiveIndex(index);
  const prev = () => setActiveIndex((prev) => (prev - 1 + SLIDES.length) % SLIDES.length);
  const next = () => setActiveIndex((prev) => (prev + 1) % SLIDES.length);

  return (
    <section id="hero" className="hero hero-education hero-with-slider">
      <div className="hero-slider">
        {SLIDES.map((slide, index) => (
          <div
            key={slide.image}
            className={`hero-slide ${index === activeIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            role="img"
            aria-label={slide.alt}
          />
        ))}
      </div>
      <div className="hero-overlay" aria-hidden="true" />
      <button type="button" className="hero-arrow hero-arrow-left" onClick={prev} aria-label="Önceki slayt">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <button type="button" className="hero-arrow hero-arrow-right" onClick={next} aria-label="Sonraki slayt">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
      <div className="hero-dots">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`hero-dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => goTo(index)}
            aria-label={`Slayt ${index + 1}`}
          />
        ))}
      </div>
      <div className="hero-content">
        <div key={activeIndex} className="hero-text hero-slide-text">
          <h1 className="hero-title">{SLIDES[activeIndex].title}</h1>
          <p className="hero-subtitle">{SLIDES[activeIndex].subtitle}</p>
          {onNavigate && (
            <button
              type="button"
              className="hero-cta-btn"
              onClick={() => onNavigate(SLIDES[activeIndex].page)}
            >
              {SLIDES[activeIndex].buttonText}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
